<template>
  <Modal :closable="false">
    <div class="modal__shields">
      <ModalShield icon="swords" />
    </div>

    <template v-if="levelId === 2">
      <h1>Спасите Элли!</h1>
      <p>
        Элли из «Одни из нас: Часть II» нужна ваша помощь, на нее напал кликер.
        Доберитесь до нее за пять ходов.
      </p>
    </template>

    <template v-if="levelId === 3">
      <h1>Набрать 1000 ед. атаки</h1>
      <p>
        В мире PlayStation 5 нужно быть готовым ко всему. Получите 1000 ед.
        атаки. Да, это возможно!
      </p>
    </template>

    <div class="modal__actions">
      <button class="button" data-size="big" @click="start">
        Вперед!
      </button>
    </div>

    <img src="../assets/img/divider.svg" class="modal__divider" />
    <div class="modal__info">
      <p>А вы знали, что <span v-html="getRandomFact()" /></p>
    </div>
  </Modal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Modal from "./Modal";
import ModalShield from "./ModalShield";
import getRandomFact from "../helpers/getRandomFact";

export default {
  components: { Modal, ModalShield },
  data: function() {
    return {
      links: {
        gamesList:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhizl&pr=%random%"
      },
      pixels: {
        startBtn:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhizm&pr=%random%&ptrc=b",
        levels: [
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdf&pr=%random%&ptrc=b",
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdh&pr=%random%&ptrc=b",
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdc&pr=%random%&ptrc=b"
        ]
      }
    };
  },
  computed: mapState(["levelId"]),
  methods: {
    getRandomFact,
    ...mapMutations(["startLevel"]),
    start() {
      this.$store.commit("toggleModal", "levelStart");
      this.$metrika.showPixel(this.pixels.levels[this.levelId - 1]);
      this.startLevel();
    }
  },
  mounted() {
    if (this.levelId <= 1 && this.$store.state.modals.levelStart) {
      // close modals of 0 and 1 levels
      this.$store.commit("toggleModal", "levelStart");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal__actions {
  .button {
    max-width: 225px;
  }
}
</style>
